import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CancelRounded from '@mui/icons-material/CancelRounded';
import CheckCircleRounded from '@mui/icons-material/CheckCircleRounded';
import ExpandMoreRounded from '@mui/icons-material/ExpandMoreRounded';
import WarningRounded from '@mui/icons-material/WarningRounded';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
const ValidationSummary = ({ checks }) => {
    const { t } = useTranslation();
    const items = [
        {
            key: 'businessIdVerified',
            label: t('applicationDetail.validation.businessId'),
            passed: checks.businessIdVerified,
        },
        {
            key: 'strongAuthCompleted',
            label: t('applicationDetail.validation.strongAuth'),
            passed: checks.strongAuthCompleted,
        },
    ];
    const passedCount = items.filter((item) => item.passed).length;
    const allPassed = passedCount === items.length;
    return (_jsxs(Accordion, { defaultExpanded: !allPassed, disableGutters: true, sx: {
            boxShadow: 'none',
            border: 1,
            borderColor: 'divider',
            borderRadius: 1,
            '&::before': { display: 'none' },
        }, children: [_jsx(AccordionSummary, { expandIcon: _jsx(ExpandMoreRounded, {}), sx: { minHeight: 48 }, children: _jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1 }, children: [allPassed ? (_jsx(CheckCircleRounded, { color: "success", fontSize: "small" })) : (_jsx(WarningRounded, { color: "warning", fontSize: "small" })), _jsxs(Typography, { variant: "body2", sx: { fontWeight: 600 }, children: [t('applicationDetail.validationTitle'), ": ", passedCount, "/", items.length, allPassed && ` - ${t('applicationDetail.validationOk')}`] })] }) }), _jsx(AccordionDetails, { sx: { pt: 0 }, children: items.map((item) => (_jsxs(Box, { sx: { display: 'flex', alignItems: 'center', gap: 1, mb: 0.5 }, children: [item.passed ? (_jsx(CheckCircleRounded, { color: "success", sx: { fontSize: 18 } })) : (_jsx(CancelRounded, { color: "error", sx: { fontSize: 18 } })), _jsx(Typography, { variant: "body2", color: item.passed ? 'text.primary' : 'error', children: item.label })] }, item.key))) })] }));
};
export default ValidationSummary;
